import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  showLoader: false,
  roleStatusStore: [],
  storeRoleMasterData: undefined,
  storeUserMasterData: [],
  storeUpdateUserResponse: {},
  storeAllPermissions: [],
  storeUserListByDepartment: [],
  storeAllRoles: [],
  storeGroupRoles: [],
  storeCreateRoleRes: {},
  storeUpdateRoleRes: {},
  storeActiveSessions: [],
  storeDeleteUserRes: {},
  storeDeleteRoleRes: {},
  storeEditRoleRes : {}
};

export const roleMasterSlice = createSlice({
  name: "roleMaster",
  initialState,
  reducers: {
    startLoading(state) {
      state.showLoader = true;
    },
    stopLoading(state) {
      state.showLoader = false;
    },
    hasError(state, action) {
      state.showLoader = false;
      state.error = action.payload;
    },
    handleStoreRoleStatus(state, action) {
      state.showLoader = false;
      state.roleStatusStore = action.payload;
    },
    handleStoreRoleMasterData(state, action) {
      state.showLoader = false;
      state.storeRoleMasterData = action.payload;
    },
    handleStoreAllPermissions(state, action) {
      state.storeAllPermissions = action.payload;
    },
    handleStoreUserMasterData(state, action) {
      state.showLoader = false;
      state.storeUserMasterData = action.payload;
    },
    handleStoreUpdateUserResponse(state, action) {
      state.showLoader = false;
      state.storeUpdateUserResponse = action.payload;
    },
    handleStoreUserListByDepartment(state, action) {
      state.showLoader = false;
      state.storeUserListByDepartment = action.payload;
    },
    handleStoreAllRoles(state, action) {
      state.storeAllRoles = action.payload;
    },
    handleStoreGroupRoles(state, action) {
      state.showLoader = false;
      state.storeGroupRoles = action.payload;
    },
    handleStoreUpdateRoleRes(state, action) {
      state.showLoader = false;
      state.storeUpdateRoleRes = action.payload;
    },
    handleStoreCreateRoleRes(state, action) {
      state.showLoader = false;
      state.storeCreateRoleRes = action.payload;
    },
    handleStoreActiveSessions(state, action) {
      state.showLoader = false;
      state.storeActiveSessions = action.payload;
    },
    handleStoreDeleteUserRes(state, action) {
      state.showLoader = false;
      state.storeDeleteUserRes = action.payload;
    },
    handleStoreDeleteRoleRes(state, action) {
      state.showLoader = false;
      state.storeDeleteRoleRes = action.payload;
    },
    handleStoreEditRoleRes(state, action) {
      state.showLoader = false;
      state.storeEditRoleRes = action.payload;
    }
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  handleStoreRoleStatus,
  handleStoreRoleMasterData,
  handleStoreUserMasterData,
  handleStoreUpdateUserResponse,
  handleStoreAllPermissions,
  handleStoreUserListByDepartment,
  handleStoreAllRoles,
  handleStoreGroupRoles,
  handleStoreUpdateRoleRes,
  handleStoreCreateRoleRes,
  handleStoreActiveSessions,
  handleStoreDeleteUserRes,
  handleStoreDeleteRoleRes,
  handleStoreEditRoleRes
} = roleMasterSlice.actions;
export default roleMasterSlice.reducer;
